import { FCX } from '@core/models';
import { TextInput } from '@components/Inputs';
import { UseFormReturn } from '@core/hooks/useForm';
import { BodyUpdateSurvey } from '@core/api/useSurveys';
import { TextInputType } from '@components/Inputs/TextInput/TextInput';
import { components } from '@core/api/api';
import { formatNumber } from '@core/utils/string';

const CONFIG: Array<{
    title: string;
    key: keyof components['schemas']['ItemsPerRespondent'];
}> = [
    { title: 'express items:', key: 'express' },
    { title: 'full concepts:', key: 'conceptLocker' },
    { title: 'public items:', key: 'regular' },
    { title: 'scores plus items:', key: 'scoresPlus' },
    { title: 'scores enterprise items:', key: 'scoresEnterprise' },
];

const PerRespondent: FCX<{
    totalSurveySample?: number;
    form: UseFormReturn<BodyUpdateSurvey>;
}> = ({
    totalSurveySample,
    form: {
        state: { itemsPerRespondent },
        actions
    }
}) => {
    if (!itemsPerRespondent) {
        return null;
    }

    return (
        <>
            <div className="SurveyDetails__spacer"></div>
            <div className="SurveyDetails__param-column">
                <div className="SurveyDetails__section-title">Per Respondent</div>
                {CONFIG.map((config) => (
                    <div key={config.key} className="SurveyDetails__param-row">
                        <div className="SurveyDetails__param-title">{config.title}</div>
                        <div className="SurveyDetails__param-value text-input">
                            <TextInput
                                type={TextInputType.NUMBER}
                                value={`${itemsPerRespondent[config.key] ?? ''}`}
                                setValue={(v) => actions.setNestedField(`itemsPerRespondent.${config.key}`, v)}
                                isSmall
                            />
                        </div>
                    </div>
                ))}
                <div className="SurveyDetails__param-row">
                    <div className="SurveyDetails__param-title uppercase">total survey SAMPLE:</div>
                    <div className="SurveyDetails__param-value right-align" style={{ marginTop: '3px' }}>
                        {totalSurveySample ? formatNumber(totalSurveySample): '—'}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PerRespondent;
